import { useState } from "react";
import { useDisclosure } from "@chakra-ui/react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Text,
} from "@chakra-ui/react";
import { toast } from "../utils/toast.utils";

type DeleteAction = (...args: any) => Promise<void>;

type UseConfirmDeleteReturn = {
    confirmDelete: (onDelete: DeleteAction, resourceName?: string) => void;
    ConfirmDeleteModal: () => JSX.Element;
    isLoading: boolean;
};

export const useConfirmDelete = (): UseConfirmDeleteReturn => {
    const [onDelete, setOnDelete] = useState<DeleteAction | null>(null);
    const [resourceName, setResourceName] = useState<string | undefined>(undefined);
    const { isOpen, onOpen, onClose } = useDisclosure();

    // This doesn't return properly
    const [isLoading, setIsLoading] = useState(false);

    const handleConfirmDelete = async () => {
        if (onDelete) {
            try {
                setIsLoading(true);
                await onDelete();
                toast(`Successfully Deleted ${resourceName ?? 'Item'}`);
            } catch (error) {

            } finally {
                setIsLoading(false);
            }
        }
        onClose();
    };

    const confirmDelete = (deleteAction: DeleteAction, name?: string) => {
        setOnDelete(() => deleteAction);
        setResourceName(name);
        onOpen();
    };

    const ConfirmDeleteModal = (): JSX.Element => (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Confirm Delete</ModalHeader>
                <ModalBody>
                    <Text>
                        Are you sure you want to delete this {resourceName ? `${resourceName}? ` : "this item? "}It cannot be undone.
                    </Text>
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme="red" mr={3} onClick={handleConfirmDelete}>
                        Confirm
                    </Button>
                    <Button variant="ghost" onClick={onClose}>
                        Cancel
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );

    return { confirmDelete, ConfirmDeleteModal, isLoading };
};
